import React, { Component } from "react";
import { connect } from "react-redux";
import SearchComponent from "./SearchComponent";
import UserInterruption from "./UserInterruption";
import AppMenu from "../../components/pages/AppMenu";

class SearchRootComponent extends Component {
  state = {
    cancelSources: [],
    canSources: {},
  };
  componentDidMount() {}

  userInterruption = (sourceName, cancelSource) => {
    const canSources = this.state.cancelSources;
    const canSrcs = Object.keys(canSources);
    if (canSrcs.find((a) => a === sourceName)) {
      delete canSources[sourceName];
    }
    canSources[sourceName] = cancelSource;
    const cancelSources = this.state.cancelSources;
    cancelSources.push(cancelSource);
    this.setState({ canSources, cancelSources });
  };

  workerCompleted = (sourceName) => {
    const canSources = this.state.cancelSources;
    const canSrcs = Object.keys(canSources);
    if (canSrcs.find((a) => a === sourceName)) {
      delete canSources[sourceName];
    }
    const cancelSources = this.state.cancelSources;
    cancelSources.pop();
    this.setState({ canSources, cancelSources });
  };

  handleCancelRequest = () => {
    if (this.state.cancelSources.length > 0) {
      for (let i = 0; i < this.state.cancelSources.length; i += 1) {
        this.state.cancelSources[i].cancel("User cancelled");
      }
      this.setState({ cancelSources: [] });
    }
  };

  render() {
    return (
      <div className="container-fluid padding-top-20">
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
        />
        <UserInterruption
          displayCancel={this.state.cancelSources.length > 0}
          handleCancelRequest={this.handleCancelRequest}
        />
        <SearchComponent
          {...this.props}
          userInterruption={this.userInterruption}
          workerCompleted={this.workerCompleted}
          uiData={this.props.uiData}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(SearchRootComponent);



// WEBPACK FOOTER //
// ./src/components/searches/SearchRootComponent.js